import * as UI from "@accurx/design";
import styled from "styled-components";

export const StyledFormFieldFeedback = styled(UI.FormFieldFeedback)`
    * {
        font-size: ${UI.Tokens.TYPOGRAPHY.note.desktop.fontSize};
    }
`;
